var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnvelop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 425.197 566.929",
    style: {
      enableBackground: "new 0 0 425.197 566.929"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M124.832,345.696V221.233h175.534v124.463H124.832z M131.134,332.395l43.409-64.602l-43.409-36.713V332.395z        M133.892,339.407h157.493l-45.694-67.595l-33.089,27.495l-33.095-27.495L133.892,339.407z M212.602,291.113l75.867-63.577H136.806       L212.602,291.113z M294.063,332.395V231.081l-43.409,36.713L294.063,332.395z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelop);
export default __webpack_public_path__ + "static/media/envelop.a30e928fb5768185f517aba58b85b513.svg";
export { ForwardRef as ReactComponent };